import { render } from "./SkincareTips.vue?vue&type=template&id=0517e7dc&scoped=true"
import script from "./SkincareTips.vue?vue&type=script&lang=js"
export * from "./SkincareTips.vue?vue&type=script&lang=js"

import "./SkincareTips.vue?vue&type=style&index=0&id=0517e7dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0517e7dc"]])

export default __exports__